export const titleArray = [
  _TL_('Insert the tracking tag using a website editing platform'), // general step title for WordPress/Shopify/Wix/BigCommerce
  _TL_('Connect your Google Tag Manager account'),
  _TL_('Set up UET tag on your Google Tag Manager account'),
  _TL_('Next steps'),
];

export const defaultConfig = IsGTMCloningChecked => ({
  '@odata.type': '#Model.GoogleTagManagerImportTaskItem',
  Type: 'GoogleTagManagerImport',
  NotificationType: 'Always',
  ImportUserPreference: {
    Version: '3.0',
    ImportNewEntities: typeof IsGTMCloningChecked === 'boolean' ? IsGTMCloningChecked : true,
    '@odata.type': '#Model.ImportUserPreference',
  },
});

export const errorCodeMapping = {
  // GoogleTagManagerWorkspaceCouldNotBeCreated
  65251: _TL_('We have encountered an error while adding your UET tag with Google Tag Manager. Please ensure that you have less than 3 pre-existing workspaces in the Google Tag Manager container you\'re using.'),
  // GoogleTagManagerPublishFailed
  65252: _TL_('We have encountered an error while publishing your UET tag with Google Tag Manager. Please ensure that you have the permissions to publish tags in the affected container.'),
  // GoogleTagManagerImportFailed
  65253: _TL_('We have encountered an error while adding your UET tag with Google Tag Manager. Please contact support and provide them with the details of this problem.'),
  // GoogleTagManagerTagCreationFailed
  65254: _TL_('We have encountered an error while adding your UET tag with Google Tag Manager. Please contact support and provide them with the details of this problem.'),
  // CustomerNotEnabledForGTMImport
  65255: _TL_('You are not authorized to perform this action. Please contact support and provide them with the details of this problem.'),
};
